import React, {useState, useEffect} from 'react'
import {withRouter} from 'react-router'
import {useFormReducerHook} from '../../utils/customHooks'
import {useCentralApiHook} from '../../utils/apiHelper'
import {API_URL_RESOURCE} from '../../utils/constants'
import {useSettings} from '../../utils/Settings'

import FormBuilder from '../../components/FormBuilder'
import PasswordChangedSuccessfully from '../../components/PasswordChangedSuccessfully'
import {Button, Grid, FormHelperText} from '@material-ui/core/'
import ReportProblemOutlinedIcon from '@material-ui/icons/ReportProblemOutlined'
import RegexMatchDashboard from '../../components/RegexMatchDashboard'
import MarkdownRender from '../../components/MarkdownRender'
import {Link} from 'react-router-dom'
import Loader from '../../components/Loader'
import queryString from 'query-string'
import Cryptr from 'cryptr'
import {saveResetPassword, getValidateSession} from '../../services/outReach'
import {Redirect} from 'react-router-dom'
import rehypeRaw from 'rehype-raw'
import ReactMarkdown from 'react-markdown'

const ResetPassword = props => {
    const {
        formData,
        updateFormData: setFormData,
        errorsData,
        updateValidationData,
        validate,
    } = useFormReducerHook()
    const [updateError, setUpdateError] = useState('')

    const {id} = queryString.parse(props.location.search)
    const [resetSuccess, setResetSuccess] = useState(false)
    const {appConfig, login} = useSettings()
    const [submitLoading, setSubmitLoading] = useState(false)
    const [toLogin, setToLogin] = useState(false)

    const {data, loading} = useCentralApiHook(
        API_URL_RESOURCE.URL + 'clientprogram/validate/resetpasswordtoken',
        {},
        {authorization: id}
    )

    const submitForm = async () => {
        setSubmitLoading(true)
        if (validate()) {
            setTimeout(async () => {
                const CRYPTR_ASE_KEY = '60jIL#jEm8eIhR1F2zo!jD7s^3ZEfmY3'
                const cryptr = new Cryptr(CRYPTR_ASE_KEY)
                const encryptedPassword = cryptr.encrypt(formData.password)
                const response = await saveResetPassword({
                    token: id,
                    password: encryptedPassword,
                })
                setSubmitLoading(false)
                if (Object.entries(response.error).length > 0) {
                    setUpdateError(response.error.message)
                } else {
                    if (response?.success?.continuetoken)
                        continueAfterResetPassword(response.success.continuetoken)
                    else {
                        setResetSuccess(true)
                        props.onResetSuccess()
                    }
                }
            }, 500)
        } else {
            setSubmitLoading(false)
        }
    }

    const goToLogin = () => {
        setToLogin(true)
        //window.location = '/login'
    }

    const actionMethods = (type, payload) => {
        switch (type) {
            case 'enterOnKeyUp':
                submitForm()
                break
            case 'onChange':
                break
            default:
                break
        }
    }

    const continueAfterResetPassword = continuetoken => {
        const callAPI = async () => {
            const result = await getValidateSession(continuetoken)
            if (result.url) window.location.assign(result.url)
            else if (result.ispasswordreset) login()
        }
        callAPI()
    }

    useEffect(() => {
        document.title = appConfig.pageTitle.resetpassword
    }, [appConfig.pageTitle.resetpassword])

    const loginPath =
        process.env.REACT_APP_ISMYACCOUNT === 'yes' ? '/login-my-account' : '/login'

    if (loading) return <Loader />
    if (toLogin) return <Redirect to={loginPath} />
    if (data === true)
        return (
            <Grid item xs className="login__contanier reset-password__contanier">
                {' '}
                {resetSuccess ? (
                    <PasswordChangedSuccessfully onLoginClick={goToLogin} />
                ) : (
                    <Grid item className="login__signin">
                        <Grid item className="login__head">
                            <FormBuilder
                                fields={appConfig.resetPasswordFormProps}
                                formData={formData}
                                setFormData={setFormData}
                                onSubmit={submitForm}
                                errorsData={errorsData}
                                updateValidation={updateValidationData}
                                actionMethods={actionMethods}
                            />
                        </Grid>
                        <Grid item xs className="reset-password__wrapper">
                            <RegexMatchDashboard
                                value={formData.password}
                                compareTo={formData.confirmpassword}
                            />
                            <FormHelperText error="true">
                                <ReactMarkdown
                                    children={updateError}
                                    rehypePlugins={[rehypeRaw]}
                                />
                            </FormHelperText>
                        </Grid>

                        <Grid item xs className="login__form-action">
                            <Grid item xs={12} className="loader__container">
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    onClick={submitForm}
                                    disabled={submitLoading}
                                >
                                    SUBMIT
                                </Button>
                                {submitLoading ? <Loader /> : null}
                            </Grid>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        )

    return (
        <React.Fragment>
            <div className="reset-pass__link-wrpr">
                <ReportProblemOutlinedIcon className="err-icon" />
                <MarkdownRender
                    value={appConfig.supportedLabels.resetPassword.tokenExpireInfo}
                />
                <Link className="rout--link-wrpr" to="/forgotpassword">
                    <Button variant="contained" color="primary">
                        {appConfig.supportedLabels.resetPassword.regenerateBtnTxt}
                    </Button>
                </Link>
            </div>
        </React.Fragment>
    )
}

ResetPassword.defaultProps = {
    onResetSuccess: () => {},
}
export default withRouter(ResetPassword)
